<!-- features/forms/page/forms-list/forms-list.html -->
<ui-organism-main-nav [mainText]="'forms.list.title' | translate" />

<ui-atom-spacer />
<ui-atom-text type="medium" [text]="'forms.list.subtitle' | translate"> </ui-atom-text>
<ui-atom-spacer size="spacer-xxl" />

<section class="forms-list-table">
  <ui-molecule-mat-table
    [data]="tableData"
    [columns]="tableColumns"
    [paginator]="true"
    paginationMode="server"
    [totalItems]="totalItems"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [isLoading]="isLoading"
    [actions]="tableActions"
    [showClearFiltersButton]="false"
    (actionClick)="onTableAction($event)"
    (rowClick)="onTableRowClick($event)"
    (pageChange)="onTablePageChange($event)"
    (sortChange)="onTableSortChange($event)"
    (filterChange)="onTableFilterChange($event)"
    (globalSearch)="onGlobalSearch($event)"
  >
    @if (canCreateForms) {
      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [text]="'forms.list.actions.create' | translate"
        (click)="goToCreate()"
      >
      </ui-atom-button>
    }
  </ui-molecule-mat-table>
</section>
